import AdvanteIcons from "../AdvanteIcons"; 
import CreditCardBase from "./../../images/credit-card-base.webp"
import CreditCardEffect from "./../../images/credit-card-effect.webp"

import PaymentCone from "./../../images/payment-cone.webp"
import PaymentCube from "./../../images/payment-cube.webp"
import PaymentDonut from "./../../images/payment-donut.webp"

const Header = () => {
    return (
        <section className='payment-header' >
            <div className="bgr-noise"></div>
            <div className="containerFull">
                <div className="payment-header-wrapper">
                    <div className="payment-header-copy">
                        <div className="payment-header-icon">
                            <AdvanteIcons 
                                type="IcoPaymentsSolutions" 
                                fill="var(--heart-purple)"
                            />
                        </div>
                        <h2>Payment &amp; Subscription Systems.</h2>
                        <p>We work with Stripe, subscriptions, marketplace logic, reporting, permissions, and operational platforms where accuracy matters. We support and improve recurring billing, credits, commissions, pricing rules, and payment issue resolution — using AI-assisted engineering with human review, and protecting production with staging, QA, pull requests, and controlled deployment.</p>
                    </div>
                    <div className="payment-header-image">
                        <div className="payment-cc-base">
                            <img 
                                src={ CreditCardBase }
                                alt="Credit Card"
                                loading="lazy"
                            />
                            <div className="payment-cc-layer-effect"></div>
                            <div className="payment-cc-effect">
                                <img 
                                    src={ CreditCardEffect }
                                    alt="Credit Card Clone"
                                    loading="lazy"
                                />
                            </div>
                            <div className="payments-figures payment-cone">
                                <img 
                                    src = { PaymentCone }
                                    alt = "Figure Cone"
                                    loading="lazy"
                                />
                            </div>
                            <div className="payments-figures payment-cube">
                                <img 
                                    src = { PaymentCube }
                                    alt = "Figure Cube"
                                    loading="lazy"
                                />
                            </div>
                            <div className="payments-figures payment-donut">
                                <img 
                                    src = { PaymentDonut }
                                    alt = "Figure Donut"
                                    loading="lazy"
                                />
                            </div>
                        </div>
                        
                    </div>
                </div>
                
            </div>
        </section>
    );
  }
  
  export default Header;